'use client';

import '@/sentry.client.config';

export function SentryClientInit() {
  return null;
}
